import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizForm } = component_tool
const { WizContainer } = framework_tool
const { isType } = utils_tool
import WizTableForm from '@/containers/common/wizTableForm/wizTableForm'
const certConfig = WizTableForm.Config.cert(this, { apiParams: { state: 1 } })
const pathStageConfig = WizTableForm.Config.pathStage(this, { apiParams: {  } })

class Editor extends WizContainer {
  componentName = 'Editor'

  constructor(props) {
    super(props)
    this.state = {
    }
  }

  _ok = (data) => {
    this.doAction({
      path: 'certStage/add',
      payload: {
        key: 'certStage@add_',
        apiParams: data
      }
    })
  }

  propsAndStateOnChange = {
    save: this._saveOnChange.bind(this)
  }

  _saveOnChange(nextProps, nextState) {
    if (nextProps.save.code === 1) {
      wizNotice.success('操作成功')
      this.props.changeModal(false, true);
      let { editorSuccess } = this.props
      editorSuccess && editorSuccess();
    } else {
      wizNotice.error(nextProps.save.msg)
    }
  }

  render() {
    const { record = {} } = this.props
    const columns = [
      {
        name: 'id',
        dataIndex: 'id',
        formItem: {
          type: 'hidden'
        }
      },
      {
        title: '证书名称',
        name: 'certId',
        dataIndex: 'certId',
        formItem: {
          ...certConfig,
          initRows: record ? [{ id: record?.certId, name: record?.certName }] : [],
          diy: WizTableForm,
          selectType: 'radio',
          placeholder: '请选择证书',
          onChangeRowMap: data => {
            if (data && isType(data, 'Object')) {
              for (let [key, value = {}] of Object.entries(data)) {
                let {
                  categoryStr = '',
                } = value
                this.refs.form && this.refs.form.setFieldsValue({
                  certCategoryName: categoryStr,
                })
              }
            }
          },
          rules: [{ required: true, message: '请选择证书' }],
        }
      },
      {
        title: '证书分类',
        name: 'certCategoryName',
        dataIndex: 'certCategoryName',
        formItem: {
          type: 'diy',
          links: 'certCategoryName',
          diy: ({ linksValues }) => {
            return linksValues || record?.certCategoryName || <span/>;
          }
        }
      },
      {
        title: '路径阶段',
        name: 'stageId',
        dataIndex: 'stageId',
        formItem: {
          ...pathStageConfig,
          initRows: record ? [{ id: record?.stageId, name: record?.stageName }] : [],
          diy: WizTableForm,
          selectType: 'radio',
          placeholder: '请选择路径阶段',
          onChangeRowMap: data => {
            if (data && isType(data, 'Object')) {
              for (let [key, value = {}] of Object.entries(data)) {
                let {
                  trainPathName = '',
                } = value
                this.refs.form && this.refs.form.setFieldsValue({
                  pathName: trainPathName,
                })
              }
            }
          },
          rules: [{ required: true, message: '请选择路径阶段' }],
        }
      },
      {
        title: '路径名称',
        name: 'pathName',
        dataIndex: 'pathName',
        formItem: {
          type: 'diy',
          links: 'pathName',
          diy: ({ linksValues }) => {
            return linksValues || record?.pathName || <span/>;
          }
        }
      },
      {
        title: '状态',
        name: 'status',
        dataIndex: 'status',
        formItem: {
          initialValue: 1 ,
          type: 'radio',
          rules: [{ required: true, message: '请选择状态' }],
        },
        dict: [
          {code: 1, codeName: '启用'},
          {code: 0, codeName: '禁用'}
        ]
      },
    ]
    const formProps = {
      ref: 'form',
      columns,
      record: null,
      preview: false,
      onSubmit: this._ok,
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 16 }
      }
    }
    return <WizForm {...formProps} />
  }
}
const mapStateToProps = (state, ownProps) => {
  const { certStage } = state
  const save = modelUtils.getModelEntity(certStage, 'certStage@add_')
  return {
    save
  }
}
const options = { withRef: true }

export default connect(mapStateToProps, null, null, options)(Editor)
